import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import chooseTime from "./chooseTime";
import { fetchList } from "@/api/PMS/placeManage/placeManage";
import { fetchDict } from "@/api/MLXC/countryServe/partyManage";
import { fetchPlaceAreaList, fetchCreate, fetchUpdate, fetchDetail } from "@/api/PMS/closedRepairManage/closedRepairManage";
export default {
  props: ["keyValue", "showDialog"],
  components: {
    chooseTime: chooseTime
  },
  data: function data() {
    return {
      rules: {
        areaId: [{
          required: true,
          message: "请选择区域名称",
          trigger: "change"
        }],
        startTime: [{
          required: true,
          message: "请选择闭馆维修开始日期",
          trigger: "change"
        }],
        endTime: [{
          required: true,
          message: "请选择闭馆维修结束日期",
          trigger: "change"
        }],
        week: [{
          required: true,
          message: "请选择订场时间",
          trigger: "change"
        }],
        placeIdList: [{
          required: true,
          message: "请选择场地",
          trigger: "change"
        }],
        periodName: [{
          required: true,
          message: "请选择时间段",
          trigger: "change"
        }]
      },
      childData: {},
      companyList: [],
      statusOptions: [],
      placeOptions: [],
      periodIdList: [],
      dialogFormVisible: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    changeArea: function changeArea(e) {
      this.$set(this.childData, "placeId", "");
      this.$set(this.childData, "placeIdList", []);
      this.$set(this.childData, "periodName", "");
      this.$set(this.childData, "periodId", "");
      this.getPlace(e, "change");
    },
    changePlace: function changePlace(e) {
      var _this = this;

      if (this.childData.areaId > 0) {
        if (e.length > 0) {
          var placeNameList = [];
          e.forEach(function (element) {
            _this.placeOptions.forEach(function (ele) {
              if (element == ele.id) {
                placeNameList.push(ele.placeName);
              }
            });
          });
          this.$set(this.childData, "placeName", placeNameList.toString());
          this.$set(this.childData, "placeId", e.toString());
        } else {
          this.$set(this.childData, "placeName", "");
          this.$set(this.childData, "placeId", "");
        }
      } else {
        this.Alert({
          alertType: "error",
          message: "请选择区域名称"
        });
      }
    },
    handCreateTime: function handCreateTime(data) {
      var periodName = "";
      periodName = data.map(function (row) {
        return "".concat(row.startTime, "-").concat(row.endTime);
      }).join(",");
      var periodId = "";
      periodId = data.map(function (row) {
        return "".concat(row.id);
      }).join(",");
      this.$set(this.childData, "periodName", periodName);
      this.$set(this.childData, "periodId", periodId);
      this.dialogFormVisible = false;
    },
    handCancleTime: function handCancleTime() {
      this.dialogFormVisible = false;
    },
    choosePlace: function choosePlace() {
      if (this.childData.areaId > 0) {
        if (this.childData.periodId) {
          var newArr = this.childData.periodId.split(",").map(function (item) {
            return Number(item);
          });
          this.periodIdList = newArr;
        } else {
          this.periodIdList = [];
        }

        this.dialogFormVisible = true;
      } else {
        this.Alert({
          alertType: "error",
          message: "请选择区域名称"
        });
      }
    },
    getPlace: function getPlace(e, type) {
      var _this2 = this;

      fetchList({
        areaId: e
      }).then(function (res) {
        _this2.placeOptions = res.data.data;

        if (type == "detail") {
          var placeIdList = _this2.childData.placeId.split(",").map(Number);

          var placeNameList = _this2.childData.placeName.split(",");

          _this2.$set(_this2.childData, "placeIdList", placeIdList);

          _this2.$set(_this2.childData, "placeNameList", placeNameList);
        }
      });
    },
    getType: function getType() {
      var _this3 = this;

      fetchDict({
        dicType: "week_date"
      }).then(function (res) {
        _this3.statusOptions = res.data.data;
      });
    },
    getCompany: function getCompany() {
      var _this4 = this;

      fetchPlaceAreaList({
        page: 1
      }).then(function (res) {
        _this4.companyList = res.data.data;
      });
    },
    init: function init() {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$refs["dataForm"].clearValidate();
      });
      this.getType();
      this.getCompany();

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this5.childData = response.data.data;
          _this5.childData.week = _this5.childData.week.toString();

          _this5.getPlace(_this5.childData.areaId, "detail");
        });
      } else {
        this.childData = {};
      }
    },
    handCreate: function handCreate() {
      var _this6 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          if (_this6.childData.startTime > _this6.childData.endTime) {
            _this6.Alert({
              alertType: "error",
              message: "闭馆维修开始日期不能大于闭馆维修结束日期"
            });

            return;
          }

          if (_this6.childData.periodName == undefined || _this6.childData.periodName == "" || _this6.childData.periodName == null) {
            _this6.Alert({
              alertType: "error",
              message: "请选择时间段"
            });

            return;
          }

          if (_this6.keyValue > 0) {
            fetchUpdate(_this6.childData).then(function (res) {
              if (res.data.code == 200) {
                _this6.$emit("handCancle", true);

                _this6.Alert({
                  alertType: "update"
                });
              }
            });
          } else {
            fetchCreate(_this6.childData).then(function (res) {
              if (res.data.code == 200) {
                _this6.$emit("handCancle", true);

                _this6.Alert({
                  alertType: "add"
                });
              }
            });
          }
        } else {
          _this6.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    }
  }
};